// extracted by mini-css-extract-plugin
export default {"chart":"NewCustomer_chart__bCzrb","legend":"NewCustomer_legend__srTO3","indicator":"NewCustomer_indicator__9NyKQ","color":"NewCustomer_color__4BXgs"};